// IMPORT
import React from "react";

// CSS
import './SolutionFP.css';

// Graphics
import GraphicFP from '../global/graphics/IMG_FinancialPlanning.svg'

// Components
import CompHeading from '../../components/CompHeading'
import CompPictureText from "../../components/CompPictureText";

// SolutionFP
export default function SolutionFP() {
  return (
    <div className="SolutionFP-Content page-gap">
      <CompHeading
        Title={"Finanzplanung"}
        Subheading={"Vorausschauende Finanzplanung durch KI."}
      />
      <CompPictureText
        Title={"KI-gestützte Finanzplanung"}
        Subheading={""}
        Text={"Unsere Lösung unterstützt die Liquiditätsplanung und -steuerung " + 
          "durch die Analyse von Zahlungsströmen und -mustern. " + 
          "Sie erstellt präzise Cashflow-Prognosen, " + 
          "erkennt potenzielle Risiken frühzeitig und ermöglicht proaktive Maßnahmen " + 
          "zur Sicherung der finanziellen Stabilität. Mit der kontinuierlichen Echtzeit-Überwachung " + 
          "und präziser Prognose des Cashflows können Unternehmen schnell " + 
          "auf Veränderungen reagieren und Liquiditätsengpässe vermeiden."}
        Graphic={GraphicFP}
        GraphicAlt={"KI-gestützte Finanzplanung"}
      />
    </div>
  )
}
